export class ExamBoard {
    Id: number;
    ExamCallId: number;
    ExamCallDescription: string;
    ShiftId: number;
    ShiftDescription: string;
    Date: Date;
    Time: string;
    SubjectIds: number[];
    SubjectNames: string[];

    constructor() {
        this.SubjectIds = [];
        this.SubjectNames = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/exam-boards/exam-board.ts